<!--
  --
  -- 予定がないときのカードコンポーネント
  --
  -->
<template>
  <v-card>
    <v-card-subtitle>
      表示する予約はありません。
    </v-card-subtitle>
  </v-card>
</template>

<script>
export default {
  name: 'CNoItemCard'
}
</script>
